module.exports = __webpack_public_path__ + "static/media/snail.1bcf8430.png";